import React from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from 'gatsby';
import ReactHtmlParser from 'react-html-parser';
import LazyLoad from 'react-lazyload';
import {
  Heading,
  Image,
  Paragraph,
  IconSVG,
  Box,
  Rating,
} from 'components';
import './ReviewBox.scss';

const ReviewBox = ({additionalClass, data, id}) => {
  const { content, settings, type } = data;
  const {
    title,
    rating,
    subtitle,
    description,
  } = content;
  const { link } = settings;

  return (
    <StaticQuery
      query={graphql`
        query {
          image: file(relativePath: { eq: "awards/logo-clutch.png" }) {
            childImageSharp {
              fluid(maxWidth: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `}
      render={data => (
        <Box
          link={link}
          id={id}
          backgroundColor={'gray-light'}
          additionalClass={`review-box__wrapper ${additionalClass}`}
        >
          <div className={'review-box__content'}>
            <Heading
              type={3}
              size={'medium-plus-small'}
              color={'cello'}
              additionalClass={'review-box__title'}
            >
              {'Testimonial: '}{ReactHtmlParser(title)}
            </Heading>
            <Paragraph
              additionalClass={'review-box__rating'}
              size={'medium'}
              color={'cello'}
              spaced
              nested
            >
              {rating}&nbsp;
                <Rating rate={rating} red />
            </Paragraph>
            <div className={'review-box__review'}>
              <Paragraph
                size={'medium'}
                color={'cello'}
              >
                {subtitle}
              </Paragraph>
              <IconSVG name={'quote'} size={'big'} color={'regent-gray'} />
            </div>
            <Paragraph
              additionalClass={'review-box__author'}
              size={'regular'}
              color={'regent-gray'}
            >
              {description}
            </Paragraph>
          </div>
          <div className={'review-box__footer review-box__footer--regent-gray'}>
            <Paragraph
              size={'small'}
              color={'regent-gray'}
              nested
            >
              {'Autenthic client review from '}
              <Image src={data.image.childImageSharp.fluid} alt={'Clutch logo'} />
            </Paragraph>
          </div>
        </Box>
      )}
    />
  );
};

ReviewBox.defaultProps = {
  additionalClass: '',
  id: '',
};

ReviewBox.propTypes = {
  additionalClass: PropTypes.string,
  id: PropTypes.string,
  data: PropTypes.object,
};

export default ReviewBox;
